'use strict'

header = document.getElementsByClassName('p-header')[0]

window.addEventListener('scroll',
  ()->
    if this.pageYOffset > 0
      header.classList.add('is-stack')
    else
      header.classList.remove('is-stack')
)
